export default "__VITE_ASSET__M1jB98Oh__"